export const UploadPhoto = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="19"
        viewBox="0 0 21 19"
        fill="none"
    >
        <path
            d="M18.9032 10.4802H13.8619V9.35989H16.1024C17.5728 9.35989 18.343 7.57442 17.2577 6.52415L11.6563 0.922678C11.0261 0.257504 9.94083 0.257504 9.31066 0.922678L3.7092 6.52415C2.62391 7.57442 3.39411 9.35989 4.89951 9.35989H7.1401V10.4802H2.09878C1.15353 10.4802 0.418335 11.2504 0.418335 12.1606V16.6418C0.418335 17.587 1.15353 18.3222 2.09878 18.3222H18.9032C19.8134 18.3222 20.5836 17.587 20.5836 16.6418V12.1606C20.5836 11.2504 19.8134 10.4802 18.9032 10.4802ZM4.89951 7.67945L10.501 2.07798L16.1024 7.67945H12.1814V13.2809H8.82054V7.67945H4.89951ZM18.9032 16.6418H2.09878V12.1606H7.1401V13.2809C7.1401 14.2262 7.87529 14.9614 8.82054 14.9614H12.1814C13.0917 14.9614 13.8619 14.2262 13.8619 13.2809V12.1606H18.9032V16.6418ZM17.5028 14.4012C17.5028 13.9461 17.1177 13.561 16.6626 13.561C16.1725 13.561 15.8224 13.9461 15.8224 14.4012C15.8224 14.8913 16.1725 15.2414 16.6626 15.2414C17.1177 15.2414 17.5028 14.8913 17.5028 14.4012Z"
            fill="#202020"
            fillOpacity="0.7"
        />
    </svg>
)
